"use client";

import React, {  } from "react";

import SectionTitle from "@components/elements/SectionTitle";
import City1 from "@components/elements/city/City1";
import Link from "next/link";

const CitySection = ({city, pages}) => {
  const currentPageAide = pages.find(item => item.id === 64);
  const currentPage = pages.find(item => item.id === 70);
  const link = currentPageAide?.seo_permalink + "/" + currentPage?.seo_permalink;

  return (
    <>
      <div className="section-padding pb-0">
        <div className="container">
          <SectionTitle
            style={1}
            title={currentPage?.seo_title}
            subTitle={<Link href={link}>{currentPage?.title}</Link>}
          />
          <div className="grid  grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-7 mt-20">
            {city.length > 0 &&
              city.map((item, i) => (
                <React.Fragment key={i}>
                  <City1 item={item} currentPageAide={currentPageAide} />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CitySection;
